module.exports = __webpack_public_path__ + "img/undraw_phone_call_re_hx6a.e62e6c75.svg";